import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import '@ifr/form-questionnaire/dist/form-questionnaire.css';
import Error from '@/components/Error.vue';
import Loader from '@/components/Loader.vue';
import UpdateSystem from '@/components/UpdateSystem.vue';
import Reauthorization from '@/components/Reauthorization.vue';
import PasswordConfirmation from '@/components/PasswordConfirmation.vue';
import Success from '@/components/Success/index.vue';
import BlockRole from '@/components/BlockRole.vue';
import BlockUser from '@/components/BlockUser.vue';
import useColorStore from '@/store/color';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

_useCssVars((_vm, _setup) => ({
  "e281d948": (_setup.btn_def)
}))

const colorStore = useColorStore();

const { theme } = storeToRefs(colorStore);
const btn_def = computed(() => theme.value.btn_def);

return { __sfc: true,colorStore, theme, btn_def, Error, Loader, UpdateSystem, Reauthorization, PasswordConfirmation, Success, BlockRole, BlockUser }
}

})